module.exports = __webpack_public_path__ + "media/images/common/shop/check-icon-6cf2b04908dceb5495f139b1165b1813.svg";